import { GtmCustomData, recordEventWrapper } from '..';
import { replaceEmptySpaceWithHyphen } from '../../utils/common';
const planGoalsSip = () => ({

  // 1. Plan your Goals with SIP home page
  planYourGoalsWithSipPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/explore-mutual-funds/plan-your-goals-with-sip/home',
    //   title: 'PFM - Online Investments - Explore Mutual Funds - Plan Your Goals with SIP - Home'
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - Plan Your Goals with SIP - Landing Screen'
    // })
  },

  // Possible values for actionType is Back, Choose your goal, I know where to invest, or Start a SIP.
  planYourGoalsWithSipOnClickEvent: (actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Plan Your Goals with SIP - Landing Screen - ${actionType}`
    // })
  },

  // 2. Choose Your Goals Page
  chooseYourGoalsPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/explore-mutual-funds/plan-your-goals-with-sip/choose-your-goal',
    //   title: 'PFM - Online Investments - Explore Mutual Funds - Plan Your Goals with SIP - Choose Your Goal'
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - Plan Your Goals with SIP - Choose Your Goal'
    // })
  },

  chooseYourGoalsBackClick: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Explore Mutual Funds - Plan Your Goals with SIP - Choose Your Goal - Back'
    // })
  },

  chooseYourGoalsContinueClick: (goal: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Plan Your Goals with SIP - Choose Your Goal - ${goal} - Continue`, 
    //   cd73: goal
    // })
  },

  // 3. Calculate your goal page
  calculateYourGoalPageLoad: (goal: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/plan-your-goals-with-sip/${replaceEmptySpaceWithHyphen(goal, true)}/calculate-your-goal`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - Plan Your Goals with SIP - ${goal} - Calculate Your Goal`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Plan Your Goals with SIP - ${goal} - Calculate Your Goal`
    // })
  },

  // actionType can have either of Back, Skip Calculator or Start a SIP as value
  calculateYourGoalOnClickEvent: (actionType: string, goal: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - Plan Your Goals with SIP - ${goal} - Calculate Your Goal - ${actionType}`
    // })
  },

  // 5. Invest Page
  investPageLoad: (scheme: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme, true)}/home`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - ${scheme} - Home`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - ${scheme} - Landing Screen`
    // })
  },

  // actionType can be Back, Terms And Conditions, Add Nominee, Edit Nominee
  investPageOnClickEvent: (scheme: string, actionType: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
      label: `${actionType}`
    })
  },

  // Data will have cd68, cd69 and cd70 values
  // TODO: check if this can be clubbed with above one
  investPageOnContinueClick: (scheme: string, data: GtmCustomData, userFlow?, isLumpsum?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} | ${scheme}`,
      label: `continue | ${isLumpsum ? "Lumpsum" : "SIP"}`,
      ...data
    })
  },

  // 6. Add nominee modal 
  investPageNomineeModalOnLoad: (scheme: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme, true)}/home/add-nominee`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - ${scheme} - Home - Add Nominee`
    // }),
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - ${scheme} - Landing Screen - Add Nominee`
    // })
  },

  // actionType here could be either Close, Remove, Add Other nominee or Confirm Nominee
  investPageNomineeModalActionClick: (scheme: string, actionType: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - ${scheme} - Landing Screen - Add Nominee - ${actionType}`
    // })
  },

  // 8. Verify OTP modal
  investPageVerifyOtpModalOnLoad: (scheme: string, userFlow) => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: `/vpv/pfm/mutual-funds/${userFlow?.toLowerCase()}/otp-verification`,
      title: `PFM - Mutual Funds - ${userFlow?.toLowerCase()} - OTP Verification`
    }),
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: 'Pageload',
      label: `mutual funds | ${userFlow?.toLowerCase()} - - otp verification`
    })
  },

  // Actiontype here can be either Close or Submit
  investPageVerifyOtpModalActionClick: (scheme: string, actionType: string, userFlow?) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual funds | ${userFlow?.toLowerCase()} - otp verification`,
      label: `success | ${scheme}`
    })
  },

  // 9. Success transact page, data will have cd71 passed from props
  investPageSuccessPageLoad: (scheme: string, data: GtmCustomData) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: `vpv/pfm/online-investments/explore-mutual-funds/${replaceEmptySpaceWithHyphen(scheme, true)}/investment-successful`,
    //   title: `PFM - Online Investments - Explore Mutual Funds - ${scheme} - Investment Successful`,
    //   ...data
    // })
  },

  investPageSuccessPageGoBackTextClick: (scheme: string, goBackMessage: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: `Explore Mutual Funds - ${scheme} - Investment Successful - ${goBackMessage}`
    // })
  }
  
});

export default planGoalsSip;